import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import { AppStateType } from '../../reducers'
import { selectPublishedGraphic } from '../../selectors/publishedGraphic'
import { selectAreaWritable } from '../../selectors/auth'
import { AREA_CONSTANTS } from '../../services/auth'
import { PublishedGraphicPage as Page } from './PublishedGraphicPage'

const mapStateToProps = (
  state: AppStateType
) => {
  const publishedGraphic = selectPublishedGraphic(state)
  return {
    publishedGraphic,
    hasGroupAccess: selectAreaWritable(state, {
      groupId: publishedGraphic.group,
      area: AREA_CONSTANTS.GROUP_PUBLISHING_AREA,
    }),
  }
}

export const PublishedGraphicPage = withRouter(connect(mapStateToProps)(Page))
